import {
  Box,
  Circle,
  Flex,
  HStack,
  Select,
  Stack,
  Switch,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import CautionAlertDialog from '../../../components/CautionAlertDialog';
import { inviteGuest } from '../service/inviteGuest';
import { daysOfTheWeek } from './inviteData';
import RandomPicker from './RandomPicker';
import RandomSummary from './RandomSummary';
import RangeSummary from './RangeSummary';
import ShareInviteLink from './ShareInviteLink';
import ShareModal from './ShareModal';
import Summary from './Summary';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../../app/constants';
import { timeout } from '../../../components/utils/timeout';
import { getDatesWithinDateRange } from '../../../components/utils/getNumberOfWeeksBtwTwoDates';

const CustomizeVisitModal = (props) => {
  const today = new Date();
  const navigate = useNavigate();
  const { MY_ESTATE } = PROTECTED_PATHS;
  const [recurrence, setRecurrence] = useState('Weekly');
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [days, setDays] = useState([]);
  const [allowCompany, setAllowCompany] = useState(false);
  const [loading, setLoading] = useState(false);
  const [guestCode, setGuestCode] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRandomDates, setSelectedRandomDates] = useState([]);

  const initialValues = {
    tenantCode: sessionStorage.getItem('tenantCode'),
    userId: sessionStorage.getItem('userId'),
    name: props.name,
    phone: props.phone,
    oneTimeVisit: false,
    allowCompany,
    startDate: dayjs(today).format('YYYY-MM-DD'),
    endDate: dayjs(today).format('YYYY-MM-DD'),
    days: [],
    // recurring: true,
  };

  const [customVisitValues, setCustomVisitValues] = useState(initialValues);

  const handleStartDate = (date) => {
    setStartDate(date);
    const formated = dayjs(date).format('YYYY-MM-DD');
    const formatedDate = formated;

    setCustomVisitValues((values) => ({
      ...values,
      startDate: formatedDate,
    }));
  };
  const handleEndDate = (date) => {
    setEndDate(date);
    const formated = dayjs(date).format('YYYY-MM-DD');
    const formatedDate = formated;

    setCustomVisitValues((values) => ({
      ...values,
      endDate: formatedDate,
    }));
  };

  const handleRepeatOn = (e) => {
    if (days.includes(e.target.innerText)) {
      removeDay(e.target.innerText);
      return;
    }
    setDays([...days, e.target.innerText]);
    console.log(days, 'days');
    setCustomVisitValues((customVisitValues) => ({
      ...customVisitValues,
      recurring: true,
      days: [...days, e.target.innerText],
    }));
  };

  const removeDay = (day) => {
    console.log('id', day);
    const remainingSelectedDays = days.filter((d) => d !== day);
    console.log('remainingSelectedDays', remainingSelectedDays);
    setDays(remainingSelectedDays);
    setCustomVisitValues((customVisitValues) => ({
      ...customVisitValues,
      days: remainingSelectedDays,
    }));
  };

  const handleAllowCompany = () => {
    setAllowCompany(!allowCompany);
    setCustomVisitValues((values) => ({
      ...values,
      allowCompany: !allowCompany,
    }));
  };

  const handleCustomInvite = () => {
    console.log('customVisitValues inner', customVisitValues);
    inviteGuest(
      customVisitValues,
      setLoading,
      setGuestCode,
      onOpen,
      onClose,
      navigate
    );
  };

  const handleShareClose = () => {
    onClose();
    timeout(() => navigate(MY_ESTATE), 1000);
  };

  return (
    <>
      <Stack spacing='4'>
        <Text fontWeight='600' textAlign='center' fontSize='1.2rem'>
          Customize your visit
        </Text>
        <HStack gap='1rem'>
          <Select
            size='sm'
            maxW='150px'
            value={recurrence}
            onChange={(e) => setRecurrence(e.target.value)}
          >
            <option>Weekly</option>
            <option>Random dates</option>
            <option>Date Range</option>
          </Select>
        </HStack>
        {recurrence === 'Weekly' ? (
          <Box>
            <Text>Repeat on</Text>
            <HStack wrap='wrap'>
              {daysOfTheWeek.map((day) => (
                <Circle
                  h='40px'
                  cursor='pointer'
                  w='40px'
                  key={day}
                  name={day}
                  bg={days.includes(day) ? 'primaryDark' : 'bgColorLight'}
                  color={days.includes(day) ? '#fff' : ''}
                  fontWeight={600}
                  fontSize='12px'
                  _active={{ bg: 'lightPink' }}
                  onClick={handleRepeatOn}
                >
                  {day}
                </Circle>
              ))}
            </HStack>
          </Box>
        ) : recurrence === 'Random dates' ? (
          <Box>
            <RandomPicker
              setSelectedRandomDates={setSelectedRandomDates}
              setCustomVisitValues={setCustomVisitValues}
            />
          </Box>
        ) : null}

        <Box>
          <Text pr='3' as='small'>
            Allow Company
          </Text>
          <Switch isChecked={allowCompany} onChange={handleAllowCompany} />
        </Box>

        {recurrence !== 'Random dates' && (
          <Flex justify='space-between' wrap='wrap' py='5'>
            <Stack zIndex='10'>
              <Text>Start date</Text>
              <DatePicker
                minDate={new Date()}
                dateFormat={'dd/MM/yyyy'}
                selected={startDate}
                onChange={(date) => handleStartDate(date)}
              />
            </Stack>
            <Stack>
              <Text>End date</Text>
              <DatePicker
                minDate={new Date()}
                selected={endDate}
                dateFormat='dd/MM/yyyy'
                onChange={(date) => handleEndDate(date)}
              />
            </Stack>
          </Flex>
        )}

        <CautionAlertDialog
          onContinue={handleCustomInvite}
          loading={loading}
          button='Send Invite'
          buttonProps={{ bg: 'primaryDark' }}
        >
          {recurrence === 'Date Range' ? (
            <RangeSummary customVisitValues={customVisitValues} />
          ) : recurrence === 'Random dates' ? (
            <RandomSummary
              selectedRandomDates={selectedRandomDates}
              customVisitValues={customVisitValues}
            />
          ) : (
            <Summary
              getDatesWithinDateRange={() =>
                getDatesWithinDateRange(startDate, endDate)
              }
              customVisitValues={customVisitValues}
              name={props.name}
              phone={props.phone}
            />
          )}
        </CautionAlertDialog>
      </Stack>
      <ShareModal isOpen={isOpen} onOpen={onOpen} onClose={handleShareClose}>
        <ShareInviteLink onClose={onClose} guestCode={guestCode} />
      </ShareModal>
    </>
  );
};

export default CustomizeVisitModal;
